import React, {useState } from 'react';
import { PhoneButton } from 'dyl-components';
import { Grid, Popup, Form, Icon } from 'semantic-ui-react';
import { Controller } from 'react-hook-form';
import { SearchableOptions } from "dyl-components";
import TransferSearchResults from './transferSearch';
import "./index.scss";
import { PhoneUtil } from 'utils';

const Transfer = ({ 
    children, 
    open, 
    onClickTransfer,
    isReadingTransferDestinations,
    transferDestinations,
    searchTransfer, 
    transferControl, 
    transferValid,
    transferDirty,
    isTransferringCall,
    isDialer
}) => { 
    const [search, setSearch] = useState("");
    const [isSearchResultsVisible, setIsSearchResultsVisible] = useState(false);
    const [focusedPhones, setFocusedPhones] = useState([]);

    const addFocus = (type) => {
        setFocusedPhones([...focusedPhones, type]);
    };
    const removeFocus = (type) => {
        setFocusedPhones(focusedPhones.filter(phone => phone !== type));
    }
    const isFocused = (type) => {
        return focusedPhones.includes(type);
    }
    const searchFunction = async () => {
        try {
            setIsSearchResultsVisible(true);
            await searchTransfer(search);
        } catch (e) {
            console.log(e)
        }
    }

    const cancelFunction = async () => {
        setSearch("");
        setIsSearchResultsVisible(false);
    };

    const onChangeSearch = (_, { value }) => {
        setSearch(value);
        if (!value) {
            setIsSearchResultsVisible(false);
        }
    }

    const size = isDialer ? { size: "small" } : {};
    
    return (
        <Popup
            trigger={children}
            open={open}
            content={
                <div style={{width: !isDialer ? 400 : 350, padding: '5px 10px 5px 10px'}}>
                    <Grid>
                        <Grid.Row>
                            <Controller 
                                name={'phoneNumber'}
                                control={transferControl}
                                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                                    <Form.Input
                                        {...size}
                                        className={`Transfer__TransferInput`}
                                        placeholder='Enter Phone Number'
                                        onChange={(_, { value }) => { 
                                            onChange({ target: { name, value } }) 
                                        }}
                                        value={!isFocused(name) && value?.length > 0 ? PhoneUtil.formatPhoneNumber(value) : value}
                                        fluid
                                        error={error?.message}
                                        action={
                                            <div className={`Transfer__button${(!transferValid || !transferDirty) ? '--disabled' : ''}`}>
                                                <Popup
                                                    trigger={
                                                        <Icon 
                                                            className='fa-solid fa-arrow-right' 
                                                            onClick={() => onClickTransfer(null)}
                                                            disabled={(!transferValid || !transferDirty)}
                                                            {...!isDialer ? { size: "large" } : {}}
                                                        />
                                                    }
                                                    inverted
                                                    content='Blind Transfer'
                                                    position='top center'
                                                />
                                            </div>
                                        }
                                        onFocus={() => {
                                            addFocus(name)
                                        }}
                                        onPaste={(e)=>{
                                            const pasted = e.clipboardData.getData('Text'); 
                                            const unformatted = PhoneUtil.getUnformatted(pasted, true);
                                            onChange({
                                                target: {
                                                    name: name,
                                                    value: unformatted,
                                                },
                                            });
                                            e.preventDefault();
                                        }}
                                        onBlur={() => {
                                            removeFocus(name)
                                            const unformatted = PhoneUtil.getUnformatted(value, true)
                                            onChange({
                                                target: {
                                                    name:name,
                                                    value: unformatted,
                                                },
                                            });
                                        }}
                                    />)}
                                />
                        </Grid.Row>
                        <Grid.Row style={{paddingTop: 0, display: 'block'}}>
                            <div className='OfficeView__transferContainer'>
                                <SearchableOptions
                                    loading={isReadingTransferDestinations}
                                    search={search}
                                    searchFunction={searchFunction}
                                    cancelSearchFunction={cancelFunction}
                                    searchPlaceholder="Name or Extension"
                                    onChangeSearch={onChangeSearch}
                                    isSearchResultsVisible={isSearchResultsVisible}
                                    renderSearchResults={
                                        <TransferSearchResults
                                            isDialer={isDialer}
                                            isReadingTransferDestinations={isReadingTransferDestinations}
                                            transferDestinations={transferDestinations}
                                            onClickTransfer={onClickTransfer}
                                            isTransferringCall={isTransferringCall}
                                            setIsSearchResultsVisible={setIsSearchResultsVisible}
                                        />
                                    }
                                    isPaginationVisible={false}
                                    small={isDialer}
                                />
                            </div>
                        </Grid.Row>
                    </Grid>
                </div>
            }
            position='bottom left'
            on='click'
            basic
            size={!isDialer ? "huge" : "small"}
        />
    )
}

const OfficeViewActionButtons = ({ 
    hangup,
    hangupDisabled = false,
    vmDrop,
    vmDropDisabled = false,
    transfer,
    transferDisabled = false,
    hold,
    holdDisabled = false,
    mute,
    muteDisabled = false,
    inboundCall,
    actionButtons,
    onClickTransfer,
    transferControl,
    transferValid,
    isReadingTransferDestinations,
    transferDestinations,
    searchTransfer,
    transferDirty,
    isTransferringCall,
    isDialer
 }) => {
    const holdAndMuteButtons = (
        <>
            <Grid.Column>
                <PhoneButton small={isDialer} text={actionButtons?.hold ? "Resume" : "Hold"} icon={actionButtons?.hold ? "fa-solid fa-play" : "fa-solid fa-pause"} iconColor="orange" onClick={hold} disabled={holdDisabled} isClicked={actionButtons?.hold} />
            </Grid.Column>
            <Grid.Column>
                <PhoneButton small={isDialer} text={actionButtons?.mute ? "Unmute" : "Mute"} icon={actionButtons?.mute ? "fa-solid fa-microphone-slash" : "fa-solid fa-microphone"} iconColor="grey" onClick={mute} disabled={muteDisabled} isClicked={actionButtons?.mute} />
            </Grid.Column>
        </>
    )
    return (
        <Grid className={`OfficeViewActionButtons${isDialer ? ' OfficeViewActionButtons--dialer' : ''}`} columns="equal">
            <Grid.Row>
                <Grid.Column>
                    <PhoneButton small={isDialer} text="Hang Up" icon="fa-solid fa-phone-hangup" iconColor="red" onClick={hangup} disabled={hangupDisabled} isClicked={actionButtons?.hangup} />
                </Grid.Column>
                {!inboundCall &&
                    <Grid.Column>
                        <PhoneButton small={isDialer} text="VM Drop" icon="fa-solid fa-voicemail" iconColor="blue" onClick={vmDrop} disabled={vmDropDisabled} isClicked={actionButtons?.vmDrop} />
                    </Grid.Column>
            }
                {inboundCall &&
                    <Grid.Column>
                        <Transfer 
                            open={actionButtons?.transfer} 
                            onClickTransfer={onClickTransfer} 
                            transferControl={transferControl} 
                            transferValid={transferValid} 
                            isReadingTransferDestinations={isReadingTransferDestinations}
                            transferDestinations={transferDestinations}
                            searchTransfer={searchTransfer}
                            transferDirty={transferDirty}
                            isTransferringCall={isTransferringCall}
                            isDialer={isDialer}
                        >
                            <PhoneButton small={isDialer} onClick={transfer} text="Transfer" icon="fa-solid fa-right-left" iconColor="blue" disabled={transferDisabled} isClicked={actionButtons?.transfer} />
                        </Transfer>
                    </Grid.Column>
                }
            </Grid.Row>
            <Grid.Row>
                {!inboundCall &&
                    <Grid.Column>
                        <Transfer 
                            open={actionButtons?.transfer} 
                            onClickTransfer={onClickTransfer} 
                            transferControl={transferControl} 
                            transferValid={transferValid} 
                            isReadingTransferDestinations={isReadingTransferDestinations}
                            transferDestinations={transferDestinations}
                            searchTransfer={searchTransfer}
                            transferDirty={transferDirty}
                            isDialer={isDialer}
                        >
                            <PhoneButton small={isDialer} onClick={transfer} text="Transfer" icon="fa-solid fa-right-left" iconColor="blue" disabled={transferDisabled} isClicked={actionButtons?.transfer} />
                        </Transfer>
                    </Grid.Column>
                }
                {!isDialer && (
                    holdAndMuteButtons
                )}
            </Grid.Row>
            {isDialer && (
                <Grid.Row columns={'equal'}>
                    {holdAndMuteButtons}
                </Grid.Row>
            )}
        </Grid>
    )
};

export default OfficeViewActionButtons;
